export default class AvailableTranslationCacheName {
  static getAvailableTranslation(): string {
    return "availableTranslation";
  }
}
